import styled, { css } from 'styled-components';

export const AnimationBackdrop = styled.div`
  ${({ theme }) =>
    theme.name === 'dark' &&
    css`
      padding: ${theme.layout.spacing(1)};
      border-radius: 50%;
      background: ${theme.palette.neutral[800]};
    `}
`;
